/* eslint-disable no-debugger */
import container from '@ioc';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { DashboardDetails, DashboardServiceClient } from 'clientportalshared';
import { IAuthenticationService, IAuthenticationService$ } from '@services/auth/IAuthentication.interface';
import ILoggingService, { ILoggingService$ } from '@services/logging/ILoggingService.interface';
import appConfig from '@config/appConfig';
import { allPortfolioDashboardDetailsThunkPayload } from '../../constants';

export const getAllPortfolioDashboardAsync = createAsyncThunk<DashboardDetails>(allPortfolioDashboardDetailsThunkPayload, async () => {
  const authService = container.get<IAuthenticationService>(IAuthenticationService$);
  const loggingService = container.get<ILoggingService>(ILoggingService$);
  const dashboardClient = new DashboardServiceClient(appConfig.apiEndpointUrl, authService, loggingService, appConfig);
  return await dashboardClient.getDashboardDetailsAsync();
});
